import React, { useEffect, useState, useRef } from "react";
import {
  Alert,
  Button,
  Form,
  Modal,
  Col,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { ListPlaceholder } from "../../Components/ui/listPlaceholder/listPlaceholder";
import { isPageInDR } from "../../dr/Components/drFuncs";
import { UploadPDFModal } from "./UploadPdfModal";
import { RenAIImport } from "./RenAIImport";
import {
  AnalysisResult,
  deleteAnalyzedDocument,
  getAnalyzedDocuments,
  getAPSDisplayName,
  getAPSDisplayShort,
  getDisplayDateTimeFromMS,
  IProps,
  parseRenAIResponse,
  uploadToStorage,
} from "./renaiFuncs";
import { useAppSelector } from "../../redux/hooks";
import {
  lddStateObject,
  setCreateFileFromAPSUpload,
  setSelectedLawyer,
  setSkipSetThirdPartyData,
  setRenAIMortgageSuccess,
  setShowRenAIModal,
} from "../../redux/reducer";
import { displayToastMsg } from "../../Components/toastMessages/toastmessages";
import { getDataReader, RPWDataReader } from "../../livedataFuncs";
import { useDispatch } from "react-redux";
import { ThirdPartyDispatch } from "../../Components/ThirdPartyList/ThirdPartyFuncs";
import { DocsDropbox } from "../../Components/MortgageAnalyzer/DocsDropbox";
import AnalyzerFuncs from "../../Components/MortgageAnalyzer/analyzer";
import { LoadingIcon } from "../../Components/Loading";
import styles from "./RenAI.module.scss";

export const RenAIRightSide = (props: IProps) => {
  // const [showModal, setShowModal] = useState(false);
  const showModal = useAppSelector((state: lddStateObject) => state.ShowRenAIModal)
  const [showMortgageModal, setShowMortgageModal] = useState(false);
  const [analysisResults, setAnalysisResults] = useState<
    Array<Record<string, any>>
  >([]);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [responseData, setResponseData] = useState<any>(null);
  const [isLoadingResults, setIsLoadingResults] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState<any>(null);
  const [base64Content, setBase64Content] = useState<any>(null);
  const [documentName, setDocumentName] = useState<string>(null);
  const [LddDocLink, setLddDocLink] = useState<string>(null);
  const responseDataRef = useRef<any>(null);
  const SESSION_INFO = useAppSelector(
    (state: lddStateObject) => state.SessionInfo,
  );
  const livedataRootContainer = useAppSelector(
    (state: lddStateObject) => state.currentNavigation.livedataRootContainer,
  );
  const createFileFromAPSUpload = useAppSelector(
    (state: lddStateObject) => state.CreateFileFromAPSUpload,
  );
  const renaiMortgageSuccess = useAppSelector(
    (state: lddStateObject) => state.RenAIMortgageSuccess,
  );
  const dispatch = useDispatch();
  const setShowModal = (state: boolean) => dispatch(setShowRenAIModal(state));
  let DataReaderObj: RPWDataReader;
  let AppID: string;
  const AIName = "RenAI";
  const APSDisplayName = getAPSDisplayName(SESSION_INFO.appProvinceShort);
  const APSDisplayShort = getAPSDisplayShort(SESSION_INFO.appProvinceShort);
  
  let drawerClasses = "";
  if (props.sidebarshow === AIName && props.toggleState === true) {
    drawerClasses = " open";
  }

  useEffect(() => {
    if (!showMortgageModal && !showResponseModal) {
      setResponseData(null);
      responseDataRef.current = null;
    }
  }, [showMortgageModal, showResponseModal]);

  useEffect(() => {
    const fetchAnalyzedDocuments = async () => {
      setIsLoadingResults(true);
      try {
        const data = await getAnalyzedDocuments(SESSION_INFO, AppID);
        data.result.forEach((result) => {
          if (result.analyzerResponse) {
            AnalyzerFuncs.processAnalyzedData(result.analyzerResponse);
          }
        });
        setAnalysisResults(data.result);
      } catch (error) {
        console.error("Error fetching analyzed documents:", error);
      } finally {
        setIsLoadingResults(false);
      }
    };
    if (AppID) {
      fetchAnalyzedDocuments();
    }
  }, [props.sidebarshow]);

  useEffect(() => {
    const fetchAnalyzedDocuments = async () => {
      setIsLoadingResults(true);
      try {
        const data = await getAnalyzedDocuments(SESSION_INFO, AppID);
        data.result.forEach((result) => {
          if (result.analyzerResponse) {
            AnalyzerFuncs.processAnalyzedData(result.analyzerResponse);
          }
        });
        setAnalysisResults(data.result);
      } catch (error) {
        console.error("Error fetching analyzed documents:", error);
      } finally {
        setIsLoadingResults(false);
      }
    };

    if (renaiMortgageSuccess && AppID) {
      fetchAnalyzedDocuments();
      setTimeout(() => {
        dispatch(setRenAIMortgageSuccess(false));
      }, 100);
    }
  }, [renaiMortgageSuccess, AppID]);

  if (livedataRootContainer.dataRoot) {
    DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
    AppID = DataReaderObj.getAppId();
  }

  if (
    props.datarootContainer?.dataRoot === undefined ||
    isPageInDR(props.page)
  ) {
    return <></>;
  }


  const handleAnalyze = async (file: File, images: string[]) => {
    try {
      await uploadToStorage(
        file,
        images,
        SESSION_INFO,
        AppID,
        DataReaderObj?.getPSM(),
        async (data) => {
          displayToastMsg(
            {
              id: null,
              msg: "Document analyzed successfully",
              type: "success",
            },
            null,
          );
          const parsedEntry = {
            analyzerResponse: data,
            pdfFileName:
              data.pdfInfo.fileName || data.result.docUploadDisplayName.value,
            documentName: "Agreement of Purchase and Sale",
            formType: data.result.docUploadDisplayName.value,
            dateTime: getDisplayDateTimeFromMS(
              data.scanDate ?? data.pdfInfo.lastModified,
            ),
            base64Content: URL.createObjectURL(file),
            LddDocLink: data?.LddDocLink,
          };
          let parsedData = parseRenAIResponse(
            JSON.parse(JSON.stringify(data)),
            SESSION_INFO?.appProvinceShort,
          );
          responseDataRef.current = parsedData;
          setResponseData(parsedData);
          setLddDocLink(data?.LddDocLink);
          setAnalysisResults((prevResults: AnalysisResult[] | undefined) =>
            prevResults ? [...prevResults, parsedEntry] : [parsedEntry],
          );
          setShowResponseModal(true);
          setBase64Content(data.base64Content);
          setShowMortgageModal(false);
          setShowModal(false);
          dispatch(setCreateFileFromAPSUpload(false));
        },

        (errorCode) => {
          displayToastMsg(
            {
              id: null,
              msg: errorCode || "Failed to analyze document",
              type: "error",
            },
            null,
          );
          setShowModal(false);
        },
      );
    } catch (error) {
      displayToastMsg(
        { id: null, msg: "An unexpected error occurred", type: "error" },
        null,
      );
      setShowModal(false);
    }
  };

  const handleCardClick = (result: any) => {
    const analyzerResponse = JSON.parse(
      JSON.stringify(result?.analyzerResponse),
    );
    const base64Content = result?.base64Content;
    const noneLenderDoc = analyzerResponse.pdfInfo ? true : false;

    if (result.documentName === "Agreement of Purchase and Sale") {
      const LddDocLink =
        result?.LddDocLink || result?.analyzerResponse?.LddDocLink;
      setShowMortgageModal(false);
      setShowResponseModal(false);
      setTimeout(() => {
        setResponseData(
          parseRenAIResponse(analyzerResponse, SESSION_INFO?.appProvinceShort),
        );
        setBase64Content(base64Content);
        setLddDocLink(LddDocLink);
        setShowResponseModal(true);
      }, 0);
    } else if (result.documentName === "Mortgage Instructions") {
      setShowResponseModal(false);
      setShowMortgageModal(false);
      setTimeout(() => {
        const responseDataToSet = noneLenderDoc
          ? analyzerResponse.result
          : analyzerResponse;

        if (noneLenderDoc && analyzerResponse.result) {
          AnalyzerFuncs.processAnalyzedData(analyzerResponse.result);
          setResponseData(analyzerResponse.result);
        } else if (!noneLenderDoc && analyzerResponse) {
          AnalyzerFuncs.processAnalyzedData(analyzerResponse);
          setResponseData(analyzerResponse);
        } else {
          setResponseData(responseDataToSet);
        }

        setShowMortgageModal(true);
        setBase64Content(base64Content);
        setDocumentName(result?.pdfFileName);
      }, 0);
    }
  };

  const handleMortgageButtonClick = () => {
    setResponseData(null);
    responseDataRef.current = null;
    setShowResponseModal(false);
    ThirdPartyDispatch(dispatch, "MortgageDropbox", false);
    setTimeout(() => {
      setShowMortgageModal(true);
      ThirdPartyDispatch(dispatch, "MortgageDropbox", true);
      setDocumentName(null);
      setBase64Content(null);
    }, 50);
  };

  const handleDeleteClick = (event: React.MouseEvent, result: any) => {
    event.stopPropagation(); // Prevent card click event
    setDocumentToDelete(result);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async (docType: string, docId: string) => {
    try {
      setShowDeleteModal(false);
      const result = await deleteAnalyzedDocument(
        SESSION_INFO,
        AppID,
        docId,
        docType,
      );

      if (result.ok) {
        displayToastMsg(
          { id: null, msg: "Document deleted successfully", type: "success" },
          null,
        );

        // Remove the deleted document from the local state
        setAnalysisResults((prevResults) =>
          prevResults.filter((doc) => {
            const currentDocId =
              doc.documentName === "Mortgage Instructions"
                ? doc.analyzerResponse?.LddDocLink
                : doc.LddDocLink;
            return currentDocId !== docId;
          }),
        );
      } else {
        displayToastMsg(
          { id: null, msg: "Failed to delete document", type: "error" },
          null,
        );
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      displayToastMsg(
        {
          id: null,
          msg: "An error occurred while deleting document",
          type: "error",
        },
        null,
      );
    } finally {
      setDocumentToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setDocumentToDelete(null);
  };

  const RenAIHeader = () => {
    return (
      <div className="toolbar-header">
        <h2>
          <i className="renai-icon renai-pill"></i> Document Analyzer
        </h2>
      </div>
    );
  };

  const RenAIInstructions = () => {
    return (
      <p>
        {`Upload ${APSDisplayShort.match('^[aieouAIEOU].*')? "an" : "a"} `}
        <b>{APSDisplayName}</b> or <b>Mortgage Instructions</b> to analyze and
        import information to your file.
      </p>
    );
  };

  const RenAIUploadOptions = ({
    setShowModal,
    handleMortgageButtonClick,
  }: {
    setShowModal: (show: boolean) => void;
    handleMortgageButtonClick: () => void;
  }) => {
    return (
      <>
        <h3 className="mb-2 mt-3">Analyze New Document</h3>

        {DataReaderObj &&
        DataReaderObj?.getPSM() !== "P" &&
        DataReaderObj?.getPSM() !== "S" ? (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip>
                {`${APSDisplayShort}s are available for Purchase and Sale files only.`}
              </Tooltip>
            }
          >
            <span className="d-inline-block">
              <Button
                variant="primary"
                className="text-start mb-1 w-100"
                onClick={() => setShowModal(true)}
                disabled={true}
                style={{ pointerEvents: "none" }}
              >
                <i className="fa-solid fa-file-arrow-up"></i>
                {APSDisplayName}
              </Button>
            </span>
          </OverlayTrigger>
        ) : (
          <Button
            variant="primary"
            className="text-start mb-1"
            onClick={() => setShowModal(true)}
          >
            <i className="fa-solid fa-file-arrow-up"></i>
            {APSDisplayName}
          </Button>
        )}

        <Button
          variant="primary"
          className="text-start"
          style={{ margin: "0" }}
          onClick={handleMortgageButtonClick}
        >
          <i className="fa-solid fa-file-arrow-up"></i>
          Mortgage Instructions
        </Button>
      </>
    );
  };

  const AgreementCard = ({ result }: { result: any }) => {
    return (
      <Row className="gx-0">
        <Col xs="auto" style={{ width: "22px" }}>
          <i className={"fas fa-file-contract " + styles.docIcon}></i>
        </Col>
        <Col className="text-truncate">
          <div className={styles.title + " text-truncate"}>
            {result.formType}
          </div>
          <div className={styles.subtitle + " text-truncate"}>
            {getDisplayDateTimeFromMS(result.dateTime)} • {result.pdfFileName}
          </div>
        </Col>
        <Col xs="auto" style={{ alignContent: "center" }}>
          <i className={styles.hoverIcon + " fas fa-eye"}></i>
          <i
            className={styles.hoverIcon + " fas fa-trash-alt"}
            onClick={(e) => handleDeleteClick(e, result)}
          ></i>
        </Col>
      </Row>
    );
  };

  const MortgageInstructionsCard = ({ result }: { result: any }) => {
    const truncatedFileName =
      result.pdfFileName?.length > 20
        ? `${result.pdfFileName.substring(0, 20)}..`
        : result.pdfFileName;

    return (
      <Row className="gx-0">
        <Col xs="auto" style={{ width: "22px" }}>
          <i className={"fas fa-file-contract " + styles.docIcon}></i>
        </Col>
        <Col className="text-truncate">
          <div className={styles.title + " text-truncate"}>
            {result.documentName}
          </div>
          <div className={styles.subtitle + " text-truncate"}>
            {getDisplayDateTimeFromMS(result.dateTime)} • {truncatedFileName}
          </div>
        </Col>
        <Col xs="auto" style={{ alignContent: "center" }}>
          <i className={styles.hoverIcon + " fas fa-eye"}></i>
          <i
            className={styles.hoverIcon + " fas fa-trash-alt"}
            onClick={(e) => handleDeleteClick(e, result)}
          ></i>
        </Col>
      </Row>
    );
  };

  const DefaultCard = ({ result }: { result: any }) => {
    const truncatedFileName =
      result.pdfFileName?.length > 20
        ? `${result.pdfFileName.substring(0, 20)}..`
        : result.pdfFileName;

    return (
      <Row className="gx-0">
        <Col xs="auto" style={{ width: "22px" }}>
          <i className="fas fa-file-alt"></i>
        </Col>
        <Col className="text-truncate">
          <div className={styles.title + " text-truncate"}>
            {result.documentName}
          </div>
          <div className={styles.subtitle + " text-truncate"}>
            {getDisplayDateTimeFromMS(result.dateTime)} • {truncatedFileName}
          </div>
        </Col>
        <Col xs="auto" style={{ alignContent: "center" }}>
          <i className={styles.hoverIcon + " fas fa-eye"}></i>
          <i
            className={styles.hoverIcon + " fas fa-trash-alt"}
            onClick={(e) => handleDeleteClick(e, result)}
          ></i>
        </Col>
      </Row>
    );
  };

  const RenAIAnalyzedDocuments = ({
    isLoadingResults,
    analysisResults,
    handleCardClick,
  }: {
    isLoadingResults: boolean;
    analysisResults: Array<Record<string, any>>;
    handleCardClick: (result: any) => void;
  }) => {
    return (
      <>
        <h3 className="mt-3 mb-2">Analyzed Documents History</h3>
        {isLoadingResults ? (
          <LoadingIcon
            showMsg={true}
            extraMsg="Loading analyzed documents"
            inline={true}
          />
        ) : analysisResults && analysisResults.length === 0 ? (
          <ListPlaceholder
            icon="fa-solid fa-file-arrow-up"
            title="No documents analyzed"
            msg="Analyzed documents will appear here."
          ></ListPlaceholder>
        ) : (
          <div style={{ overflow: "auto" }}>
            {analysisResults
              ?.sort(
                (a, b) =>
                  new Date(b.dateTime).getTime() -
                  new Date(a.dateTime).getTime(),
              )
              ?.map((result, index) => (
                <OverlayTrigger
                  delay={800}
                  placement="left"
                  overlay={
                    <Tooltip>
                      {getDisplayDateTimeFromMS(result.dateTime)} •{" "}
                      {result.pdfFileName}
                    </Tooltip>
                  }
                >
                  <div
                    key={`analyzedDocument-${index}`}
                    className={styles.analysisResultCard}
                    style={{
                      cursor: [
                        "Agreement of Purchase and Sale",
                        "Mortgage Instructions",
                      ].includes(result.documentName)
                        ? "pointer"
                        : "default",
                    }}
                    onClick={() => handleCardClick(result)}
                  >
                    {result.documentName ===
                    "Agreement of Purchase and Sale" ? (
                      <AgreementCard result={result} />
                    ) : result.documentName === "Mortgage Instructions" ? (
                      <MortgageInstructionsCard result={result} />
                    ) : (
                      <DefaultCard result={result} />
                    )}
                  </div>
                </OverlayTrigger>
              ))}
          </div>
        )}
      </>
    );
  };

  return (
    <div className={"toolbar-content " + drawerClasses} key="RenAIRightSide">
      <RenAIHeader />
      <div className="toolbar-body">
        <RenAIInstructions />
        <RenAIUploadOptions
          setShowModal={setShowModal}
          handleMortgageButtonClick={handleMortgageButtonClick}
        />
        <RenAIAnalyzedDocuments
          isLoadingResults={isLoadingResults}
          analysisResults={analysisResults}
          handleCardClick={handleCardClick}
        />

        <UploadPDFModal
          show={showModal || createFileFromAPSUpload}
          onHide={() => {
            setShowModal(false);
            dispatch(setCreateFileFromAPSUpload(false));
          }}
          onAnalyze={handleAnalyze}
          title={`Upload ${APSDisplayName}`}
          docType="aps"
          appCode={SESSION_INFO?.appProvinceShort}
        />

        {responseData && (
          <RenAIImport
            key={responseData?.id || "aps-import"}
            show={showResponseModal}
            onHide={() => {
              setShowResponseModal(false);
              dispatch(setSelectedLawyer(null));
              dispatch(setSkipSetThirdPartyData(false));
            }}
            responseData={responseData}
            base64Content={base64Content}
            LddDocLink={LddDocLink}
            DataReaderObj={DataReaderObj}
          />
        )}

        {showMortgageModal && (
          <DocsDropbox
            key={responseData?.id || "docs-dropbox"}
            fileLocation={"--ldd-default-renai-request"}
            responseData={responseData}
            base64Content={base64Content}
            uploadDoc={documentName}
          />
        )}

        <Modal
          show={showDeleteModal}
          onHide={handleDeleteCancel}
          size="sm"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert variant="warning" className="mb-2">
              Are you sure you want to delete this document? <br />
              <b>This action cannot be undone.</b>
            </Alert>
            {documentToDelete && (
              <Row>
                <Form.Group as={Col} xs="6" className="mb-2">
                  <Form.Label>Document Type</Form.Label>
                  <p>{documentToDelete.documentName}</p>
                </Form.Group>

                <Form.Group as={Col} xs="6" className="mb-2">
                  <Form.Label>
                    {documentToDelete.documentName === "Mortgage Instructions"
                      ? "Lender"
                      : "Document Name"}
                  </Form.Label>
                  <p>{documentToDelete.pdfFileName}</p>
                </Form.Group>

                <Form.Group as={Col}>
                  <Form.Label>Scan Date</Form.Label>
                  <p>{documentToDelete.dateTime}</p>
                </Form.Group>
              </Row>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-primary" onClick={handleDeleteCancel}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() =>
                handleDeleteConfirm(
                  documentToDelete.documentName === "Mortgage Instructions"
                    ? "Mortgage"
                    : documentToDelete.analyzerResponse.pdfInfo.docType,
                  // documentToDelete.documentName === 'Mortgage Instructions' ? documentToDelete.analyzerResponse.LddDocLink : documentToDelete.LddDocLink
                  documentToDelete.analyzerResponse.LddDocLink ||
                    documentToDelete.LddDocLink,
                )
              }
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
